/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-negation */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import $ from "jquery";
import API from "../../utils/API";
import Html from "../../utils/Html";
import ZoomChart from "./create.chart.zoom";
import Function from "./function";

import TreeRole from "./chart/TreeRole";
import Tree from "./chart/Tree";
import SelectType from "./chart/SelectType";
import { StaffNumbers, GetUserRoots } from "./chart/utils";
import "./chart/chart.css";

export default function CreateChart({
  userData,
  orgData,
  showFullnameAndPosition }) {
  const userID = userData.idu;
  // console.log("userID=", userID);

  const [chartData, setChartData] = useState({
    data: orgData,
    type: "hybrid",
    status: "",
    err: 0,
    err_msg: "" });
  //const [chartData, setChartData] = useState({data: orgData, type: 'functional', status: '', err: 0, err_msg: ''});
  // const [chartData, setChartData] = useState({
  //   data: orgData,
  //   type: "role",
  //   status: "",
  //   err: 0,
  //   err_msg: "",
  // });
  var curDown = false,
    curYPos = 0,
    curXPos = 0;
  const handleEvents = {
    SelectType: {
      OnChange: function (evt) {
        let value = evt.target.value;
        //console.log(value);
        setChartData((prev) => ({
          ...prev,
          data: orgData,
          type: value,
          status: "",
          err: 0,
          err_msg: "" }));
      } } };

  useEffect(() => {
    Function.ImagesLoad("tree", chartData.status, {
      style: { border: "3px solid #fff" } });
    StaffNumbers();

    $("#tree").on("mousedown", function (m) {
      //$("#org-content").on("mousedown", "#tree", function(m){
      curYPos = m.pageY;
      curXPos = $(this).scrollLeft() + m.pageX;
      curDown = true;
    });
    $("#tree").on("mousemove", function (m) {
      if (curDown) {
        $(this).scrollLeft(curXPos - m.pageX);
        //console.log("Mousemove");
      }
    });
    $("#tree").on("mouseup", function () {
      curDown = false;
    });

    $(".btn-user-role").off("click");
    $(".btn-user-role").on("click", function () {
      let elem = $(this);
      let user_id = elem.attr("user-id");
      setChartData((prev) => ({
        ...prev,
        status: "processing" }));
      const mainFunc = async () =>
        await API.post("org/role/data", {
          params: ({
            userID: userID,
            idu: user_id }) });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("response=", decrypt);
          if (decrypt?.status === "success") {
            // setChartData({ ...chartData, decrypt });
            setChartData(decrypt);
          } else {
            setChartData((prev) => ({
              ...prev,
              status: "",
              err: 1,
              err_msg: `Failes : ` + decrypt?.err_msg ?? "" }));
          }
        })
        .catch((err) => {
          console.log(`Failes : ${err}`);
          setChartData((prev) => ({
            ...prev,
            status: "",
            err: 1,
            err_msg: err }));
        });
    });

    $("#org-content").off("click", ".btn-expend");
    $("#org-content").on("click", ".btn-expend", function () {
      let elem = $(this);
      //let btn = $(elem).find(".btn-expend").first();
      let btn = elem;
      let dept_id = btn.attr("dept-id");
      let ol_elem = $(".sub-dept-" + dept_id);
      if (btn.hasClass("active")) {
        btn.removeClass("active");
        elem.find(".icon-add").first().removeClass("hide");
        elem.find(".icon-remove").first().addClass("hide");
        ol_elem.slideUp("1000", function () {});
      } else {
        btn.addClass("active");
        elem.find(".icon-add").first().addClass("hide");
        elem.find(".icon-remove").first().removeClass("hide");
        ol_elem.slideDown("1000", function () {});
      }
    });
    $("#org-content")
      .on("mouseenter", ".staff", function () {
        let elem = $(this);
        elem.addClass("hover");
      })
      .on("mouseleave", ".staff", function () {
        let elem = $(this);
        elem.removeClass("hover");
      });

    $("#org-content").off("click", ".role-toggle-button");
    $("#org-content").on("click", ".role-toggle-button", function () {
      const button = $(this);
      const listItem = button.closest("li");
      const childList = listItem.children("ol").first();
      if (!childList.length) return;

      const arrowIcon = button.find(".role-toggle-arrow");
      if (button.hasClass("active")) {
        button.removeClass("active");
        arrowIcon.text("keyboard_arrow_down");
        childList.stop(true, true).slideUp(300);
      } else {
        button.addClass("active");
        arrowIcon.text("keyboard_arrow_up");
        childList.stop(true, true).slideDown(300);
      }
    });
  }, [chartData, showFullnameAndPosition]);
  let content = "";
  if ("err" in chartData && chartData.err == 1) {
    content = (
      <div key="text-error-content" className="text-error">
        Fetch request error: {chartData.err_msg}
      </div>
    );
  } else if (chartData.status == "processing") {
    content = (
      <div key="preloading-content">
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "50px",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto" } }}
        />
      </div>
    );
  } else {
    let content_list = [];
    if (chartData.type == "role") {
      if (
        "user_root_id" in chartData.data &&
        chartData.data.user_root_id != ""
      ) {
        let elemIdu = chartData.data.user_root_id;
        let tmpData = {};
        tmpData.user_childs = chartData.data.user_childs;
        tmpData.user_details = chartData.data.user_details;
        tmpData.user_id = chartData.data.user_id;
        tmpData.user_elems = [elemIdu];
        tmpData.count_user_childrens = chartData.data.count_user_childrens;
        tmpData.isShowFullnameAndPosition = showFullnameAndPosition;
        tmpData.user_levels = chartData.data.user_levels ?? [];
        content_list = TreeRole(tmpData, 0, content_list);
      } else {
        let userRoots = GetUserRoots(chartData.data);
        content_list = TreeRole(
          {
            user_childs: chartData.data.user_childs,
            user_details: chartData.data.user_details,
            user_id: "",
            user_elems: userRoots["user_root"],
            count_user_childrens: chartData.data.count_user_childrens,
            isShowFullnameAndPosition: showFullnameAndPosition,
            user_levels: chartData.data.user_levels ?? [] },
          1,
          content_list
        );

        if (content_list.length > 0) {
          let tmps = [];
          tmps.push(`<li>`);
          tmps.push(
            `<div class="level-1"><span>` +
              userRoots["dept_root"].name +
              `</span></div>`
          );
          tmps.push(`<ol>`);
          tmps.push(content_list.join(""));
          tmps.push(`</ol>`);
          tmps.push(`</li>`);
          content_list = tmps;
        }
      }
    } else {
      content_list = Tree(
        chartData.data,
        chartData.type,
        chartData.data.root_id,
        showFullnameAndPosition
      );
    }
    let contents = "";
    if (content_list.length > 0) {
      contents = content_list.join("");
    }
    content = `<ol class="organizational-chart">`;
    content += contents;
    content += `</ol>`;
    content = (
      <div
        style={{ display: "flex", justifyContent: "center" }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
  return (
    <div key="inner-org-chart" id="inner-org-chart">
      <SelectType type={chartData.type} handleEvents={handleEvents} />
      <ZoomChart />
      <div id="tree">{content}</div>
    </div>
  );
}


